import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLocale } from '../../context/LocaleContext';
import { switchPathLocale } from '../../utils/lang-route';

const SiteHeader: React.FC = () => {
  const { locale, setLocale } = useLocale();
  const navigate = useNavigate();
  const location = useLocation();
  const isEn = locale === 'en';

  const changeLocale = (next: 'zh' | 'en') => {
    setLocale(next);
    navigate(`${switchPathLocale(location.pathname, next)}${location.search}`);
  };

  return (
    <header className="flex items-center justify-between gap-4 py-3.5 border-b border-[var(--dir-border)]">
      <Link to={`/${locale}`} className="dir-link flex items-center min-w-0 max-w-[70%] sm:max-w-none">
        <img
          src={`${process.env.PUBLIC_URL}/forprojourneylogo.png`}
          alt="For Pro Journey"
          className="h-20 sm:h-[5.5rem] w-auto max-w-full object-contain object-left"
          decoding="async"
        />
      </Link>
      <nav className="flex items-center gap-2 text-sm text-[var(--dir-muted)] shrink-0">
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => changeLocale('zh')}
            className={`dir-link text-sm ${!isEn ? 'font-medium text-[var(--dir-text)]' : ''}`}
          >
            中文
          </button>
          <span className="text-[var(--dir-border)] select-none" aria-hidden>
            |
          </span>
          <button
            type="button"
            onClick={() => changeLocale('en')}
            className={`dir-link text-sm ${isEn ? 'font-medium text-[var(--dir-text)]' : ''}`}
          >
            EN
          </button>
        </div>
      </nav>
    </header>
  );
};

export default SiteHeader;
